module.exports={author:"Anis Mojgani",date:"11/30/2019",publishDate:"11/30/2019",highlighted:!1,tags:"",title:"Cuesta"};